import { useAuth, canVendorAccessPortal } from "../../context/AuthContext";
import { Navigate, useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { apiClient } from "../../services/apiClientService";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, login, logout, vendor } = useAuth();
  const location = useLocation();
  const [checkingSession, setCheckingSession] = useState(true);
  const hasChecked = useRef(false);

  useEffect(() => {
    const checkSession = async () => {
      if (hasChecked.current) {
        setCheckingSession(false);
        return;
      }

      hasChecked.current = true;

      try {
        const data = await apiClient("GET", "/api/vendors/profile");

        if (canVendorAccessPortal(data)) {
          login(data);
        } else {
          console.warn("Invalid vendor status. Logging out...");
          await logout();
        }
      } catch (error) {
        console.error("Session check failed:", error.message);
        await logout(); // Force logout on any error
      } finally {
        setCheckingSession(false);
      }
    };

    // Always check session if no vendor info in context
    if (!vendor) {
      checkSession();
    } else {
      setCheckingSession(false);
    }
  }, [login, logout, vendor]);

  if (checkingSession) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center p-10">Validating session...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/vendor/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
